// import React from "react";
// import { Field, ErrorMessage } from "formik";
// import {FormGroup, FormLabel, Row,Form } from "react-bootstrap";

// const SelectInput = ({ label, name, options, ...rest }) => {
//   return (
//     <>
//     <Row >
//     <FormGroup>
//         <FormLabel htmlFor={name} className="text-dark">
//           {label}
//           <span className="text-danger">*</span>
//         </FormLabel>
//         <div>
//           <Field
//             aria-label="Default select example"
//             className="form-select "
//             style={{
//               height: "2.5rem",
//               backgroundColor: "#fff",
//             }}
//             as="select"
//             id={name}
//             name={name}
//           >
//             {options.map((option) => (
//               <option key={option.value} value={option.value}>
//                 {option.label}
//               </option>
//             ))}
//           </Field>
//           <ErrorMessage name={name} component="div" className="error-message" />
//         </div>
//       </FormGroup>
//     </Row>
//     </>
//   );
// };

// export default SelectInput;



import React from "react";
import { Field, ErrorMessage } from "formik";
import { FormGroup, FormLabel, Row, Form } from "react-bootstrap";

const SelectInput = ({ label, name, options, ...rest }) => {
  return (
    <>
      <Row>
        <FormGroup controlId={name}>
          <FormLabel className="text-dark fw-bold">
            {label}
          </FormLabel>
          <div>
            <Field
              aria-label="Default select example"
              className="form-select"
              style={{
                height: "2.5rem",
                backgroundColor: "#fff",
              }}
              as="select"
              id={name}
              name={name}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Field>
            <ErrorMessage name={name} component="div" className="error-message text-danger" />
          </div>
        </FormGroup>
      </Row>
    </>
  );
};

export default SelectInput;
